import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaxisChartsModule } from '@maxis/charts';
import { ChartModule } from '@progress/kendo-angular-charts';
import { IntlModule } from '@progress/kendo-angular-intl';
import 'hammerjs';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminChartPickerComponent } from './components/admin-chart-picker/admin-chart-picker.component';
import { AddContainerDialogComponent } from './components/admin-chart-pusher/add-container-dialog/add-container-dialog.component';
import { AdminChartPusherComponent } from './components/admin-chart-pusher/admin-chart-pusher.component';
import { AdminProfileCardComponent } from './components/admin-profile-card/admin-profile-card.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminsDialogComponent } from './components/admins-dialog/admins-dialog.component';
import { AlertsComponent } from './components/alerts/alerts.component';
import { CardIconButtonComponent } from './components/card-icon-button/card-icon-button.component';
import { ChartComponent } from './components/chart/chart.component';
import { ChartsPushedChartComponent } from './components/charts-pushed-chart/charts-pushed-chart.component';
import { ChooseUsersTableComponent } from './components/choose-users-table/choose-users-table.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { ManageChartComponent } from './components/manage-chart/manage-chart.component';
import { ManageReportGmadminComponent, SaveConfirmedDialog } from './components/manage-report-gmadmin/manage-report-gmadmin.component';
import { ManageReportSecurityComponent } from './components/manage-report-security/manage-report-security.component';
import { AddReportDialog, ManageReportsComponent, SyncReportDialog } from './components/manage-reports/manage-reports.component';
import { OptionCardComponent } from './components/option-card/option-card.component';
import { ReportEmbedComponent } from './components/report-embed/report-embed.component';
import { ReportsComponent } from './components/reports/reports.component';
import { SelectGroupDialogComponent } from './components/select-group-dialog/select-group-dialog.component';
import { SidePanelComponent } from './components/side-panel/side-panel.component';
import { TimeFramePickerComponent } from './components/time-frame-picker/time-frame-picker.component';
import { ViewReportsAsDialogComponent } from './components/view-reports-as-dialog/view-reports-as-dialog.component';
import { ViewsDailyChartComponent } from './components/views-daily-chart/views-daily-chart.component';
import { ViewsDailyReportComponent } from './components/views-daily-report/views-daily-report.component';
import { PendingChangesGuard } from './guards/can-deactivate.guard';
import { IconsModule } from './icons/icons.module';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { CustomHttpInterceptorService } from './interceptors/request-options.interceptor';
import { MaterialModule } from './material/material.module';
import { AuthServiceTonic } from './services/auth-tonic.service';
import { AuthService } from './services/auth.service';
import { ConfigService } from './services/config.service';
import { StartupService } from './startup.service';



registerLocaleData(localeFr, 'fr');


@NgModule({
  declarations: [
    AppComponent,
    SidePanelComponent,
    DashboardComponent,
    ReportsComponent,
    AdminComponent,
    AdminProfileCardComponent,
    CardIconButtonComponent,
    AdminChartPusherComponent,
    ChooseUsersTableComponent,
    OptionCardComponent,
    TimeFramePickerComponent,
    DataTableComponent,
    ChartComponent,
    ManageReportsComponent,
    AdminChartPickerComponent,
    ReportEmbedComponent,
    ManageReportSecurityComponent,
    SelectGroupDialogComponent,
    ManageChartComponent,
    ChartsPushedChartComponent,
    ViewsDailyChartComponent,
    ConfirmDialogComponent,
    AddReportDialog,
    SyncReportDialog,
    ViewsDailyReportComponent,
    AddContainerDialogComponent,
    SaveConfirmedDialog,
    ViewReportsAsDialogComponent,
    AlertsComponent,
    AdminsDialogComponent,
    ManageReportGmadminComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    IconsModule,
    FormsModule,
    ChartModule,
    HttpClientModule,
    ReactiveFormsModule,
    IntlModule,
    MaxisChartsModule
  ],
  providers: [
    CookieService,
    AuthService,
    AuthServiceTonic,
    ConfigService,
    StartupService,
    PendingChangesGuard,
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: APP_INITIALIZER, useFactory: startupServiceFactory, deps: [StartupService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptorService, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      deps: [Injector],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function startupServiceFactory(startupService: StartupService): Function {
  return () => startupService.load();
}